export const COUNT_ON_PAGE = '50';
